[ {
  "code" : "ACTK",
  "label" : "SAE action taken",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "No change",
    "i18nCodeLabel" : "No change"
  }, {
    "value" : 2,
    "sasLabel" : "Increased",
    "i18nCodeLabel" : "Increased"
  }, {
    "value" : 3,
    "sasLabel" : "Decreased",
    "i18nCodeLabel" : "Decreased"
  }, {
    "value" : 4,
    "sasLabel" : "Interrupted",
    "i18nCodeLabel" : "Interrupted"
  }, {
    "value" : 5,
    "sasLabel" : "Permanently discontinued",
    "i18nCodeLabel" : "Permanently discontinued"
  } ]
}, {
  "code" : "ACTN",
  "label" : "Action(s) taken",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "None   ",
    "i18nCodeLabel" : "None   "
  }, {
    "value" : 2,
    "sasLabel" : "Modification of a concomitant treatment   ",
    "i18nCodeLabel" : "Modification of a concomitant treatment   "
  }, {
    "value" : 3,
    "sasLabel" : "New concomitant treatment   ",
    "i18nCodeLabel" : "New concomitant treatment   "
  }, {
    "value" : 4,
    "sasLabel" : "Hospitalization   ",
    "i18nCodeLabel" : "Hospitalization   "
  }, {
    "value" : 5,
    "sasLabel" : "Study termination",
    "i18nCodeLabel" : "Study termination"
  } ]
}, {
  "code" : "DUR",
  "label" : "duration",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "&lt; 1h ",
    "i18nCodeLabel" : "&lt; 1h "
  }, {
    "value" : 2,
    "sasLabel" : "1h- 2h ",
    "i18nCodeLabel" : "1h- 2h "
  }, {
    "value" : 3,
    "sasLabel" : "2h - 3h",
    "i18nCodeLabel" : "2h - 3h"
  }, {
    "value" : 4,
    "sasLabel" : "&gt; 3h",
    "i18nCodeLabel" : "&gt; 3h"
  } ]
}, {
  "code" : "DWM",
  "label" : "days, weeks, months ",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "date",
    "i18nCodeLabel" : "date"
  }, {
    "value" : 2,
    "sasLabel" : "weeks",
    "i18nCodeLabel" : "weeks"
  }, {
    "value" : 3,
    "sasLabel" : "months",
    "i18nCodeLabel" : "months"
  }, {
    "value" : 4,
    "sasLabel" : "days",
    "i18nCodeLabel" : "days"
  } ]
}, {
  "code" : "EFF",
  "label" : "Efficacy",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Positive (improvement of the disorder)",
    "i18nCodeLabel" : "Positive (improvement of the disorder)"
  }, {
    "value" : 2,
    "sasLabel" : "Negative (worsening of the disorder)",
    "i18nCodeLabel" : "Negative (worsening of the disorder)"
  }, {
    "value" : 3,
    "sasLabel" : "No evolution (disorder initially present)",
    "i18nCodeLabel" : "No evolution (disorder initially present)"
  }, {
    "value" : 4,
    "sasLabel" : "Not applicable (disorder not initially present)",
    "i18nCodeLabel" : "Not applicable (disorder not initially present)"
  } ]
}, {
  "code" : "FRQFF",
  "label" : "Frequency of use",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never ",
    "i18nCodeLabel" : "Jamais"
  }, {
    "value" : 2,
    "sasLabel" : "Rarely (around 1 time per week)",
    "i18nCodeLabel" : "Rarement (environ 1 fois/semaine)"
  }, {
    "value" : 3,
    "sasLabel" : "Often (around 1 time per day)",
    "i18nCodeLabel" : "Souvent (environ 1 fois/jour)"
  }, {
    "value" : 4,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Toujours"
  } ]
}, {
  "code" : "FRQ2FF",
  "label" : "Frequency of refusal",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never ",
    "i18nCodeLabel" : "Jamais"
  }, {
    "value" : 2,
    "sasLabel" : "Rarely (less than 1 time per day)",
    "i18nCodeLabel" : "Rarement (moins d'une fois/jour)"
  }, {
    "value" : 3,
    "sasLabel" : "Often (more than 1 time per day)",
    "i18nCodeLabel" : "Souvent (au moins 1 fois/jour)"
  }, {
    "value" : 4,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Toujours"
  } ]
}, {
  "code" : "FRQF",
  "label" : "Frequency of use",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never ",
    "i18nCodeLabel" : "Never "
  }, {
    "value" : 2,
    "sasLabel" : "Rarely (around 1 time per week)",
    "i18nCodeLabel" : "Rarely (around 1 time per week)"
  }, {
    "value" : 3,
    "sasLabel" : "Often (around 1 time per day)",
    "i18nCodeLabel" : "Often (around 1 time per day)"
  }, {
    "value" : 4,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Always"
  } ]
}, {
  "code" : "FRQ2F",
  "label" : "Frequency of refusal",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never ",
    "i18nCodeLabel" : "Never "
  }, {
    "value" : 2,
    "sasLabel" : "Rarely (less than 1 time per day)",
    "i18nCodeLabel" : "Rarely (less than 1 time per day)"
  }, {
    "value" : 3,
    "sasLabel" : "Often (more than 1 time per day)",
    "i18nCodeLabel" : "Often (more than 1 time per day)"
  }, {
    "value" : 4,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Always"
  } ]
}, {
  "code" : "GA",
  "label" : "gestional age",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Ultrasound",
    "i18nCodeLabel" : "Ultrasound"
  }, {
    "value" : 2,
    "sasLabel" : "Date of the last menstruation",
    "i18nCodeLabel" : "Date of the last menstruation"
  }, {
    "value" : 99,
    "sasLabel" : "NK",
    "i18nCodeLabel" : "NK"
  } ]
}, {
  "code" : "GIGPRO",
  "label" : "GIGER",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never",
    "i18nCodeLabel" : "Jamais"
  }, {
    "value" : 2,
    "sasLabel" : "Almost never",
    "i18nCodeLabel" : "Presque jamais"
  }, {
    "value" : 3,
    "sasLabel" : "Sometimes",
    "i18nCodeLabel" : "Parfois"
  }, {
    "value" : 4,
    "sasLabel" : "Often",
    "i18nCodeLabel" : "Souvent"
  }, {
    "value" : 5,
    "sasLabel" : "Almost always",
    "i18nCodeLabel" : "Presque toujours"
  }, {
    "value" : 6,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Toujours"
  } ]
}, {
  "code" : "INDIC",
  "label" : "Indication (previous TRT)",
  "values" : [ {
    "value" : 2,
    "sasLabel" : "Medical History",
    "i18nCodeLabel" : null
  }, {
    "value" : 3,
    "sasLabel" : "Prophylaxis",
    "i18nCodeLabel" : null
  }, {
    "value" : 4,
    "sasLabel" : "Other",
    "i18nCodeLabel" : null
  } ]
}, {
  "code" : "INDIC2F",
  "label" : "Indication (CM)",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Adverse Event",
    "i18nCodeLabel" : null
  }, {
    "value" : 2,
    "sasLabel" : "Medical History",
    "i18nCodeLabel" : null
  }, {
    "value" : 3,
    "sasLabel" : "Prophylaxis",
    "i18nCodeLabel" : null
  }, {
    "value" : 4,
    "sasLabel" : "Other",
    "i18nCodeLabel" : null
  } ]
}, {
  "code" : "IMPVTR",
  "label" : "improvment",
  "values" : [ {
    "value" : 4,
    "sasLabel" : "Improvement",
    "i18nCodeLabel" : "Amélioration"
  }, {
    "value" : 3,
    "sasLabel" : "Worsening",
    "i18nCodeLabel" : "Détérioration"
  }, {
    "value" : 2,
    "sasLabel" : "No evolution",
    "i18nCodeLabel" : "Pas de changement"
  }, {
    "value" : 1,
    "sasLabel" : "Regurgitation not initially present",
    "i18nCodeLabel" : "Pas de régurgitations initialement "
  } ]
}, {
  "code" : "IMPVTCP",
  "label" : "improvment",
  "values" : [ {
    "value" : 4,
    "sasLabel" : "Improvement",
    "i18nCodeLabel" : "Amélioration"
  }, {
    "value" : 3,
    "sasLabel" : "Worsening",
    "i18nCodeLabel" : "Détérioration"
  }, {
    "value" : 2,
    "sasLabel" : "No evolution",
    "i18nCodeLabel" : "Pas de changement"
  }, {
    "value" : 1,
    "sasLabel" : "Constipation not initially present",
    "i18nCodeLabel" : "Pas de constipation initialement "
  } ]
}, {
  "code" : "IMPVTCL",
  "label" : "improvment",
  "values" : [ {
    "value" : 4,
    "sasLabel" : "Improvement",
    "i18nCodeLabel" : "Amélioration"
  }, {
    "value" : 3,
    "sasLabel" : "Worsening",
    "i18nCodeLabel" : "Détérioration"
  }, {
    "value" : 2,
    "sasLabel" : "No evolution",
    "i18nCodeLabel" : "Pas de changement"
  }, {
    "value" : 1,
    "sasLabel" : "Colic not initially present",
    "i18nCodeLabel" : "Pas de coliques initialement "
  } ]
}, {
  "code" : "MD",
  "label" : "Mode of delivery",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Vaginal ",
    "i18nCodeLabel" : "Vaginal "
  }, {
    "value" : 2,
    "sasLabel" : "C-section",
    "i18nCodeLabel" : "C-section"
  }, {
    "value" : 3,
    "sasLabel" : "NK",
    "i18nCodeLabel" : "NK"
  } ]
}, {
  "code" : "PAIN",
  "label" : "pain",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never",
    "i18nCodeLabel" : "Never"
  }, {
    "value" : 2,
    "sasLabel" : "Yes, only 1 time ",
    "i18nCodeLabel" : "Yes, only 1 time "
  }, {
    "value" : 3,
    "sasLabel" : "Yes, &gt; 1 time",
    "i18nCodeLabel" : "Yes, &gt; 1 time"
  } ]
}, {
  "code" : "PAIN2F",
  "label" : "pain",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never",
    "i18nCodeLabel" : "Jamais"
  }, {
    "value" : 2,
    "sasLabel" : "Yes, only 1 time ",
    "i18nCodeLabel" : "Oui, 1 seule fois"
  }, {
    "value" : 3,
    "sasLabel" : "Yes, &gt; 1 time",
    "i18nCodeLabel" : "Oui, &gt; 1 fois"
  } ]
}, {
  "code" : "QULN",
  "label" : "Qualin score",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Tout à fait faux",
    "i18nCodeLabel" : "Tout à fait faux"
  }, {
    "value" : 2,
    "sasLabel" : "Plutôt faux",
    "i18nCodeLabel" : "Plutôt faux"
  }, {
    "value" : 3,
    "sasLabel" : "Vrai et faux à la fois",
    "i18nCodeLabel" : "Vrai et faux à la fois"
  }, {
    "value" : 4,
    "sasLabel" : "Plutôt vrai",
    "i18nCodeLabel" : "Plutôt vrai"
  }, {
    "value" : 5,
    "sasLabel" : "Tout à fait vrai",
    "i18nCodeLabel" : "Tout à fait vrai"
  }, {
    "value" : 6,
    "sasLabel" : "Je ne sais pas",
    "i18nCodeLabel" : "Je ne sais pas"
  } ]
}, {
  "code" : "REAS",
  "label" : "Reason for discontinuation",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Investigator's decision   ",
    "i18nCodeLabel" : "Investigator's decision   "
  }, {
    "value" : 2,
    "sasLabel" : "Parents' decision   ",
    "i18nCodeLabel" : "Parents' decision   "
  }, {
    "value" : 3,
    "sasLabel" : "Food refusal   ",
    "i18nCodeLabel" : "Food refusal   "
  }, {
    "value" : 4,
    "sasLabel" : "Lost to follow-up   ",
    "i18nCodeLabel" : "Lost to follow-up   "
  }, {
    "value" : 5,
    "sasLabel" : "Adverse event",
    "i18nCodeLabel" : "Adverse event"
  } ]
}, {
  "code" : "REL",
  "label" : "Relation to the product ",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Not related",
    "i18nCodeLabel" : "Not related"
  }, {
    "value" : 2,
    "sasLabel" : "Related",
    "i18nCodeLabel" : "Related"
  } ]
}, {
  "code" : "RGG",
  "label" : "Volume of regurgitations",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Small volume (&le; teaspoon)",
    "i18nCodeLabel" : "Small volume (&le; teaspoon)"
  }, {
    "value" : 2,
    "sasLabel" : "Medium volume",
    "i18nCodeLabel" : "Medium volume"
  }, {
    "value" : 3,
    "sasLabel" : "Large volume (&ge; half the volume consumed)",
    "i18nCodeLabel" : "Large volume (&ge; half the volume consumed)"
  } ]
}, {
  "code" : "RGGP",
  "label" : "Volume of regurgitations",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Small volume (&le; teaspoon)",
    "i18nCodeLabel" : "Faible : &le; cuillère à café"
  }, {
    "value" : 2,
    "sasLabel" : "Medium volume",
    "i18nCodeLabel" : "Moyen"
  }, {
    "value" : 3,
    "sasLabel" : "Large volume (&ge; half the volume consumed)",
    "i18nCodeLabel" : "Important : &ge; la moitié du volume consommé "
  } ]
}, {
  "code" : "RGGFQ",
  "label" : "Frequency of regurgitations",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never ",
    "i18nCodeLabel" : "Never "
  }, {
    "value" : 2,
    "sasLabel" : "Rarely (less than 1 time per day)",
    "i18nCodeLabel" : "Rarely (less than 1 time per day)"
  }, {
    "value" : 3,
    "sasLabel" : "Regularly (1 time or more per day)",
    "i18nCodeLabel" : "Regularly (1 time or more per day)"
  }, {
    "value" : 4,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Always"
  } ]
}, {
  "code" : "RGGFQP",
  "label" : "Frequency of regurgitations",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never ",
    "i18nCodeLabel" : "Jamais"
  }, {
    "value" : 2,
    "sasLabel" : "Rarely (less than 1 time per day)",
    "i18nCodeLabel" : "Rarement (&lt; 1 fois/jour)"
  }, {
    "value" : 3,
    "sasLabel" : "Regularly (1 time or more per day)",
    "i18nCodeLabel" : "Régulièrement (&ge; 1 fois/jour)"
  }, {
    "value" : 4,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Toujours"
  } ]
}, {
  "code" : "ROUTE",
  "label" : "route",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Per os",
    "i18nCodeLabel" : "Per os"
  }, {
    "value" : 2,
    "sasLabel" : "Subcutaneous   ",
    "i18nCodeLabel" : "Subcutaneous   "
  }, {
    "value" : 3,
    "sasLabel" : "Intramuscular   ",
    "i18nCodeLabel" : "Intramuscular   "
  }, {
    "value" : 4,
    "sasLabel" : "Intravenous  ",
    "i18nCodeLabel" : "Intravenous  "
  }, {
    "value" : 5,
    "sasLabel" : "Rectal   ",
    "i18nCodeLabel" : "Rectal   "
  }, {
    "value" : 6,
    "sasLabel" : "Topical   ",
    "i18nCodeLabel" : "Topical   "
  }, {
    "value" : 7,
    "sasLabel" : "Nasal   ",
    "i18nCodeLabel" : "Nasal   "
  }, {
    "value" : 8,
    "sasLabel" : "Inhaled   ",
    "i18nCodeLabel" : "Inhaled   "
  }, {
    "value" : 9,
    "sasLabel" : "Transdermal",
    "i18nCodeLabel" : "Transdermal"
  } ]
}, {
  "code" : "SAEOUT",
  "label" : "SAE FUP",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Recovered ",
    "i18nCodeLabel" : "Recovered "
  }, {
    "value" : 2,
    "sasLabel" : "Death",
    "i18nCodeLabel" : "Death"
  }, {
    "value" : 3,
    "sasLabel" : "Recovered with sequelae",
    "i18nCodeLabel" : "Recovered with sequelae"
  }, {
    "value" : 4,
    "sasLabel" : "Ongoing and improved ",
    "i18nCodeLabel" : "Ongoing and improved "
  }, {
    "value" : 5,
    "sasLabel" : "Ongoing and unchanged ",
    "i18nCodeLabel" : "Ongoing and unchanged "
  }, {
    "value" : 6,
    "sasLabel" : "Ongoing and worsened",
    "i18nCodeLabel" : "Ongoing and worsened"
  }, {
    "value" : 99,
    "sasLabel" : "Unknown",
    "i18nCodeLabel" : "Unknown"
  } ]
}, {
  "code" : "SAT",
  "label" : "PARENT'S SATISFACTION",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Très insatisfait   ",
    "i18nCodeLabel" : "Très insatisfait   "
  }, {
    "value" : 2,
    "sasLabel" : "Insatisfait   ",
    "i18nCodeLabel" : "Insatisfait   "
  }, {
    "value" : 3,
    "sasLabel" : "Neutre  ",
    "i18nCodeLabel" : "Neutre  "
  }, {
    "value" : 4,
    "sasLabel" : "Satisfait  ",
    "i18nCodeLabel" : "Satisfait  "
  }, {
    "value" : 5,
    "sasLabel" : "Très satisfait",
    "i18nCodeLabel" : "Très satisfait"
  } ]
}, {
  "code" : "SERC",
  "label" : "Seriousness criteria ",
  "values" : [ {
    "value" : 1,
    "sasLabel" : " It resulted in death",
    "i18nCodeLabel" : " It resulted in death"
  }, {
    "value" : 2,
    "sasLabel" : " It was life threatening",
    "i18nCodeLabel" : " It was life threatening"
  }, {
    "value" : 3,
    "sasLabel" : " It required hospitalisation/prolongation of existing hospitalisation",
    "i18nCodeLabel" : " It required hospitalisation/prolongation of existing hospitalisation"
  }, {
    "value" : 4,
    "sasLabel" : " It resulted in persistent or significant disability/incapacity",
    "i18nCodeLabel" : " It resulted in persistent or significant disability/incapacity"
  }, {
    "value" : 5,
    "sasLabel" : " It was a congenital anomaly / birth defect",
    "i18nCodeLabel" : " It was a congenital anomaly / birth defect"
  }, {
    "value" : 6,
    "sasLabel" : " It was another medically important condition",
    "i18nCodeLabel" : " It was another medically important condition"
  } ]
}, {
  "code" : "SEV",
  "label" : "Severity",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Mild  ",
    "i18nCodeLabel" : "Mild  "
  }, {
    "value" : 2,
    "sasLabel" : "Moderate  ",
    "i18nCodeLabel" : "Moderate  "
  }, {
    "value" : 3,
    "sasLabel" : "Severe  ",
    "i18nCodeLabel" : "Severe  "
  }, {
    "value" : 4,
    "sasLabel" : "Life-threatening",
    "i18nCodeLabel" : "Life-threatening"
  } ]
}, {
  "code" : "SEX",
  "label" : "Sex",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Male",
    "i18nCodeLabel" : "Male"
  }, {
    "value" : 2,
    "sasLabel" : "Female",
    "i18nCodeLabel" : "Female"
  } ]
}, {
  "code" : "STOOL",
  "label" : "Stools consistency",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Hard",
    "i18nCodeLabel" : "Hard"
  }, {
    "value" : 2,
    "sasLabel" : "Formed",
    "i18nCodeLabel" : "Formed"
  }, {
    "value" : 3,
    "sasLabel" : "Loose",
    "i18nCodeLabel" : "Loose"
  }, {
    "value" : 4,
    "sasLabel" : "Watery",
    "i18nCodeLabel" : "Watery"
  }, {
    "value" : 5,
    "sasLabel" : "Other  ",
    "i18nCodeLabel" : "Other  "
  } ]
}, {
  "code" : "STOOL2F",
  "label" : "Stools consistency",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Hard",
    "i18nCodeLabel" : "Dures"
  }, {
    "value" : 2,
    "sasLabel" : "Formed",
    "i18nCodeLabel" : "Moulées"
  }, {
    "value" : 3,
    "sasLabel" : "Loose",
    "i18nCodeLabel" : "Molles"
  }, {
    "value" : 4,
    "sasLabel" : "Watery",
    "i18nCodeLabel" : "Liquides"
  }, {
    "value" : 5,
    "sasLabel" : "Other  ",
    "i18nCodeLabel" : "Autre"
  } ]
}, {
  "code" : "UNIT",
  "label" : "unit",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Other  ",
    "i18nCodeLabel" : "Other  "
  }, {
    "value" : 2,
    "sasLabel" : "mg/ml  ",
    "i18nCodeLabel" : "mg/ml  "
  }, {
    "value" : 3,
    "sasLabel" : "kg  ",
    "i18nCodeLabel" : "kg  "
  }, {
    "value" : 4,
    "sasLabel" : "g ",
    "i18nCodeLabel" : "g "
  }, {
    "value" : 5,
    "sasLabel" : "mg  ",
    "i18nCodeLabel" : "mg  "
  }, {
    "value" : 6,
    "sasLabel" : "µg  ",
    "i18nCodeLabel" : "µg  "
  }, {
    "value" : 7,
    "sasLabel" : "mg/kg  ",
    "i18nCodeLabel" : "mg/kg  "
  }, {
    "value" : 8,
    "sasLabel" : "g/m2  ",
    "i18nCodeLabel" : "g/m2  "
  }, {
    "value" : 9,
    "sasLabel" : "L  ",
    "i18nCodeLabel" : "L  "
  }, {
    "value" : 10,
    "sasLabel" : "mL  ",
    "i18nCodeLabel" : "mL  "
  }, {
    "value" : 11,
    "sasLabel" : "mmol  ",
    "i18nCodeLabel" : "mmol  "
  }, {
    "value" : 12,
    "sasLabel" : "%  ",
    "i18nCodeLabel" : "%  "
  }, {
    "value" : 13,
    "sasLabel" : "mmol/L  ",
    "i18nCodeLabel" : "mmol/L  "
  }, {
    "value" : 14,
    "sasLabel" : "mmHg  ",
    "i18nCodeLabel" : "mmHg  "
  }, {
    "value" : 15,
    "sasLabel" : "IU/L  ",
    "i18nCodeLabel" : "IU/L  "
  }, {
    "value" : 16,
    "sasLabel" : "mol/L  ",
    "i18nCodeLabel" : "mol/L  "
  }, {
    "value" : 17,
    "sasLabel" : "phial  ",
    "i18nCodeLabel" : "phial  "
  }, {
    "value" : 18,
    "sasLabel" : "drop  ",
    "i18nCodeLabel" : "drop  "
  }, {
    "value" : 19,
    "sasLabel" : "Spray",
    "i18nCodeLabel" : "Spray"
  } ]
}, {
  "code" : "VND",
  "label" : "Adapted Vandenplas score",
  "values" : [ {
    "value" : 0,
    "sasLabel" : " 0-2 episodes of regurgitation per day",
    "i18nCodeLabel" : " 0-2 episodes of regurgitation per day"
  }, {
    "value" : 1,
    "sasLabel" : "&ge; 3 but &le; 5 episodes of regurgitation per day of a small volume (&lt;1 coffee spoon per day)\n",
    "i18nCodeLabel" : "&ge; 3 but &le; 5 episodes of regurgitation per day of a small volume (&lt;1 coffee spoon per day)\n"
  }, {
    "value" : 2,
    "sasLabel" : "&gt; 5 episodes of regurgitation per day of &gt; 1 coffee spoon",
    "i18nCodeLabel" : " &gt; 5 episodes of regurgitation per day of &gt; 1 coffee spoon"
  }, {
    "value" : 3,
    "sasLabel" : " &gt; 5 episodes of regurgitation per day of about half of the feeding in less than half of the feedings",
    "i18nCodeLabel" : " &gt; 5 episodes of regurgitation per day of about half of the feeding in less than half of the feedings"
  }, {
    "value" : 4,
    "sasLabel" : "Continuous regurgitations of small volumes during &gt; 30 minutes after each feeding",
    "i18nCodeLabel" : "Continuous regurgitations of small volumes during &gt; 30 minutes after each feeding"
  }, {
    "value" : 5,
    "sasLabel" : "Regurgitation of half to complete volume of a feeding in at least half of the feedings",
    "i18nCodeLabel" : "Regurgitation of half to complete volume of a feeding in at least half of the feedings"
  }, {
    "value" : 6,
    "sasLabel" : "Regurgitation of the complete volume after each feeding",
    "i18nCodeLabel" : "Regurgitation of the complete volume after each feeding"
  } ]
}, {
  "code" : "WM",
  "label" : "weight measured",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "At time of the inclusion visit V0",
    "i18nCodeLabel" : "At time of the inclusion visit V0"
  }, {
    "value" : 2,
    "sasLabel" : "Prior to pregnancy",
    "i18nCodeLabel" : "Prior to pregnancy"
  }, {
    "value" : 3,
    "sasLabel" : "During the first 12 weeks of pregnancy",
    "i18nCodeLabel" : "During the first 12 weeks of pregnancy"
  } ]
}, {
  "code" : "Yes",
  "label" : "Yes",
  "values" : [ {
    "value" : 1,
    "sasLabel" : null,
    "i18nCodeLabel" : null
  } ]
}, {
  "code" : "YNK",
  "label" : "Yes ; No ; NK",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Yes",
    "i18nCodeLabel" : "Yes"
  }, {
    "value" : 0,
    "sasLabel" : "No",
    "i18nCodeLabel" : "No"
  }, {
    "value" : 99,
    "sasLabel" : "NK",
    "i18nCodeLabel" : "NK"
  } ]
}, {
  "code" : "NOYES",
  "label" : "Yes/no",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Yes",
    "i18nCodeLabel" : "Yes"
  }, {
    "value" : 0,
    "sasLabel" : "No",
    "i18nCodeLabel" : "No"
  } ]
}, {
  "code" : "YNNA",
  "label" : "Yes ; No ; NA",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Yes",
    "i18nCodeLabel" : "Yes"
  }, {
    "value" : 0,
    "sasLabel" : "No",
    "i18nCodeLabel" : "No"
  }, {
    "value" : 99,
    "sasLabel" : "NA",
    "i18nCodeLabel" : "NA"
  } ]
}, {
  "code" : "FRQEN",
  "label" : "Frequency of use",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Never ",
    "i18nCodeLabel" : "Never "
  }, {
    "value" : 2,
    "sasLabel" : "Rarely (around 1 time per week)",
    "i18nCodeLabel" : "Rarely (around 1 time per week)"
  }, {
    "value" : 3,
    "sasLabel" : "Often (around 1 time per day)",
    "i18nCodeLabel" : "Often (around 1 time per day)"
  }, {
    "value" : 4,
    "sasLabel" : "Always",
    "i18nCodeLabel" : "Always"
  } ]
}, {
  "code" : "YN",
  "label" : "Yes/no",
  "values" : [ {
    "value" : 1,
    "sasLabel" : "Yes",
    "i18nCodeLabel" : null
  }, {
    "value" : 0,
    "sasLabel" : "No",
    "i18nCodeLabel" : null
  } ]
}, {
  "code" : "YES1F",
  "label" : "Yes",
  "values" : [ {
    "value" : 1,
    "sasLabel" : null,
    "i18nCodeLabel" : "None"
  } ]
}, {
  "code" : "YES2F",
  "label" : "Yes",
  "values" : [ {
    "value" : 1,
    "sasLabel" : null,
    "i18nCodeLabel" : "Modification of a concomitant treatment"
  } ]
}, {
  "code" : "YES3F",
  "label" : "Yes",
  "values" : [ {
    "value" : 1,
    "sasLabel" : null,
    "i18nCodeLabel" : "New concomitant treatment"
  } ]
}, {
  "code" : "YES4F",
  "label" : "Yes",
  "values" : [ {
    "value" : 1,
    "sasLabel" : null,
    "i18nCodeLabel" : "Hospitalization"
  } ]
}, {
  "code" : "YES5F",
  "label" : "Yes",
  "values" : [ {
    "value" : 1,
    "sasLabel" : null,
    "i18nCodeLabel" : "Study termination"
  } ]
} ]